import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const InstructorCourseCardOnBundleBox = styled(Box)`
  padding-right: 12px;
  display: flex;
  flex-direction: row;

  @media only screen and (max-width: 767px) {
    margin-top: 4px;
    margin-bottom: 4px;
  }

  .avatar-instructor {
    border: solid 2px white;
    height: 25.63px;
    width: 25.63px;

    @media only screen and (max-width: 767px) {
      display: none;
    }
  }

  .instructor-info {
    font-family: 'Heavent';
    margin-left: 12px;
    font-size: 14px;
    line-height: 22px;

    @media only screen and (max-width: 767px) {
      margin-left: 0px;
      line-height: 14px;
      font-family: 'Lanna';
    }
  }
`;
// sx={{ marginLeft: '12px' }} fontSize={'14px'}
